import type { ReactNode } from "react";

import { Box, Container, Flex } from "@chakra-ui/react";

import { AppHeader } from "@shared/ui/molecules/app-header/app-header.tsx";

type Props = {
  children: ReactNode;
  navigationSlot?: ReactNode;
  profileSlot?: ReactNode;
};

export const PageTemplate = ({
  children,
  navigationSlot,
  profileSlot,
}: Props) => {
  return (
    <Flex direction="column" minH="100vh">
      <AppHeader
        appLogoSrc="/logo.svg"
        leftSlot={profileSlot}
        navigationSlot={navigationSlot}
      />
      <Container
        as={Flex}
        flex={1}
        flexDirection="column"
        maxW="lg"
        pb={navigationSlot ? "20" : undefined}
        pt="32px"
      >
        {children}
      </Container>
      {navigationSlot && (
        <Box
          background="bg.subtle"
          bottom="0"
          hideFrom="desktop"
          left="0"
          position="fixed"
          w="full"
        >
          <Container as="nav" flex={1} flexDirection="column" maxW="lg">
            {navigationSlot}
          </Container>
        </Box>
      )}
    </Flex>
  );
};
